var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShelter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    className: "me-5 icon pe-none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.86,8.55L11.4,.38c-.14-.11-.33-.11-.47,0L.45,8.54c-.09,.07-.15,.19-.15,.31v4.31c0,.15,.08,.28,.21,.35,.13,.06,.28,.05,.39-.04l1.74-1.37v9.52c0,.21,.19,.38,.4,.38H19.07c.21,0,.39-.17,.4-.38V11.95l1.93,1.51c.07,.05,.15,.08,.23,.08,.06,0,.11-.01,.16-.04,.13-.07,.21-.2,.21-.35v-4.31c0-.12-.05-.23-.15-.31ZM3.41,21.23V11.51l7.75-6.02,7.54,5.87v9.87H3.41ZM21.24,12.38L11.4,4.69c-.14-.11-.33-.11-.46,0L1.06,12.38v-3.34L11.16,1.17l10.07,7.87v3.34Z",
    fill: "rgb(22, 22, 22)",
    stroke: "rgb(22, 22, 22)",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.46,12.93c-.27-1.34-1.24-2.21-2.47-2.21-.59,0-1.22,.21-1.84,.61-.63-.42-1.25-.63-1.86-.63-1.24,0-2.2,.88-2.46,2.23-.36,1.89,.76,4.39,4.07,5.72,0,0,.01,0,.02,0,.07,.02,.15,.04,.22,.04,.08,0,.15-.01,.22-.04,0,0,.02,0,.02,0,3.31-1.35,4.43-3.85,4.07-5.72h0Zm-4.31,4.98c-2.87-1.17-3.86-3.27-3.56-4.84,.19-.99,.84-1.61,1.71-1.61,.51,0,1.07,.22,1.63,.64,.13,.1,.32,.1,.45,0,.56-.41,1.12-.62,1.62-.62,.86,0,1.52,.61,1.72,1.59,.41,2.15-1.49,3.97-3.56,4.84Z",
    fill: "rgb(22, 22, 22)",
    stroke: "rgb(22, 22, 22)",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelter);
export default __webpack_public_path__ + "static/media/shelter.3a4f84ade2e998b42bb2ca308d4f011c.svg";
export { ForwardRef as ReactComponent };